/* import __COLOCATED_TEMPLATE__ from './attribute-collector.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class AttributeCollector extends Component {
  @service attributeService;
  @service intl;

  get attributes() {
    return this.args.editorConfiguration.collectableAttributesGroupList
      .map((groupList) => groupList.attributes)
      .flat();
  }

  get attribute() {
    if (this.args.step.choiceAttributeDescriptor) {
      return this.args.step.choiceAttributeDescriptor;
    }
    return this.attributes.find(
      (attribute) => attribute.identifier === this.args.step.attributeIdentifier,
    );
  }

  get shouldAutoOpenSideSheet() {
    return this.args.step.justAdded && !this.args.readOnly && !this.args.isTemplatePreview;
  }

  @action
  resetJustAddedFlag() {
    if (this.args.step.justAdded) {
      this.args.step.justAdded = false;
    }
  }

  @action
  handleAutoOpen(element, [bodyComponent]) {
    // did-insert passes element as first arg, positional args as second
    if (this.shouldAutoOpenSideSheet) {
      this.resetJustAddedFlag();
      this.openSideSheetWithBody(bodyComponent);
    }
  }

  @action
  openSideSheetWithBody(bodyComponent) {
    this.args.editorState.openSideSheet({
      analyticsData: this.args.step.analyticsData,
      headingText: this.intl.t(
        'operator.workflows.visual-builder.attribute-collector.data-field-header',
      ),
      isTemplatePreview: this.args.isTemplatePreview,
      body: bodyComponent,
    });
  }
}
